const DEFAULT_ALLOWED_TAGS = new Set([
  'a',
  'b',
  'blockquote',
  'br',
  'code',
  'div',
  'em',
  'i',
  'li',
  'ol',
  'p',
  'pre',
  'span',
  'strong',
  'table',
  'tbody',
  'td',
  'th',
  'thead',
  'tr',
  'ul',
]);

const DEFAULT_ALLOWED_ATTRS = new Set([
  'class',
  'href',
  'rel',
  'target',
  'title',
]);

const isSafeUrl = (value) => {
  if (!value || typeof value !== 'string') {
    return false;
  }
  const trimmed = value.trim().toLowerCase();
  return (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('mailto:') ||
    trimmed.startsWith('tel:') ||
    trimmed.startsWith('#')
  );
};

const sanitizeNode = (node, allowedTags, allowedAttrs) => {
  if (!node) {
    return;
  }
  if (node.nodeType === Node.ELEMENT_NODE) {
    const tagName = node.tagName.toLowerCase();
    if (!allowedTags.has(tagName)) {
      node.remove();
      return;
    }

    [...node.attributes].forEach((attr) => {
      const name = attr.name.toLowerCase();
      const value = attr.value;
      if (!allowedAttrs.has(name)) {
        node.removeAttribute(attr.name);
        return;
      }
      if (name.startsWith('on')) {
        node.removeAttribute(attr.name);
        return;
      }
      if ((name === 'href' || name === 'src') && !isSafeUrl(value)) {
        node.removeAttribute(attr.name);
        return;
      }
    });

    if (tagName === 'a') {
      if (!node.getAttribute('rel')) {
        node.setAttribute('rel', 'noopener noreferrer');
      }
      if (!node.getAttribute('target')) {
        node.setAttribute('target', '_blank');
      }
    }
  }

  const children = Array.from(node.childNodes);
  children.forEach((child) => sanitizeNode(child, allowedTags, allowedAttrs));
};

export const sanitizeHtml = (html, options = {}) => {
  if (typeof html !== 'string') {
    return '';
  }
  const allowedTags = options.allowedTags || DEFAULT_ALLOWED_TAGS;
  const allowedAttrs = options.allowedAttrs || DEFAULT_ALLOWED_ATTRS;

  try {
    if (typeof DOMParser === 'undefined') {
      return '';
    }
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const body = doc?.body;
    if (!body) {
      return '';
    }
    sanitizeNode(body, allowedTags, allowedAttrs);
    return body.innerHTML || '';
  } catch (error) {
    return '';
  }
};
